import { Injectable, OnDestroy } from "@angular/core";
import { ClientStore, Order } from "../stores/stores";
import { CheckoutService } from "./store/store-checkout/checkout.service";
import { LocationService } from "./location.service";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { getSelectedStore } from "./store/+state/stores.selectors";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OrderService implements OnDestroy {
  selectedStore: ClientStore;

  private destroy$ = new Subject<void>();

  constructor(
    private checkoutService: CheckoutService,
    private locationService: LocationService,
    private route: ActivatedRoute,
    private store: Store
  ) {
    this.store
      .select(getSelectedStore)
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedStore) => {
        this.selectedStore = selectedStore;
      });
  }

  getInitOrder(): Order {
    const order: Order = {
      orderItems: [],
    };
    if (
      this.checkoutService.ifOnlyInStore() ||
      this.locationService.getUrlStoreLocation()
    ) {
      order.deliveryMethod = "IN_STORE_LOCATION";
    } else if (this.checkoutService.ifOnlySelfPickup()) {
      order.deliveryMethod = "NO_LOCATION";
    } else if (this.checkoutService.ifOnlyDeliveryToAddress()) {
      order.deliveryMethod = "ADDRESS";
    } else if (
      this.selectedStore.settings.DEFAULT_DELIVERY_MODE &&
      this.checkoutService.ifDeliveryMethodEnabled(
        this.selectedStore.settings.DEFAULT_DELIVERY_MODE
      )
    ) {
      order.deliveryMethod = this.selectedStore.settings.DEFAULT_DELIVERY_MODE;
    }
    if (this.route.snapshot.paramMap.get("locationid")) {
      order.locationId = parseInt(
        this.route.snapshot.paramMap.get("locationid"),
        10
      );
    }
    return order;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
